export default "__VITE_ASSET__B8nzUpOm__"